/**
 * Group Trip 回應 JSON 解析：在 JSON.parse 之前把 Snowflake ID token 轉為字串，
 * 避免超過 Number.MAX_SAFE_INTEGER 的 ID 經過 JS Number 而失去精度。
 * 主要契約仍為後端以 JSON 字串輸出 Long ID；此處為防禦性保護。
 */

const SCALAR_ID_KEYS = [
  'groupTripId', 'hostMemberId', 'applicantMemberId', 'applicationId', 'journeyId',
  'journeyActivityId', 'activityId', 'eventId', 'decisionId', 'acceptOptionId', 'keepOptionId',
  'targetActivityId', 'voterTravelerId', 'optionId', 'fromActivityId', 'toActivityId',
  'journeyPublicationId', 'publicationId', 'participantId', 'memberId', 'linkedMemberId',
  'travelerId', 'materializedTravelerId', 'requestId', 'requesterMemberId', 'subjectId',
  'openPeriodId', 'effectivePeriodId', 'actorMemberId', 'declarationId', 'viewerApplicationId',
  'viewerParticipantId', 'viewerTravelTradeId', 'noticeId', 'nextCursorNoticeId', 'nextCursorId',
  'itineraryContractPublicationRowVersion', 'caseId', 'componentId', 'bookingId', 'affectedTravelerId',
  'baselineId', 'replacesActivityId', 'replacedByActivityId', 'replacedActivityId', 'originEventId',
  'lastChangedEventId', 'locationId', 'periodId', 'participationEndId', 'createdJourneyId',
  'sourceGroupTripId', 'provenanceId',
];

// 僅限後端以 JSON number 陣列輸出的 ID 陣列；非 ID 數值陣列（如 LocalDateTime 陣列）不得列入。
const ID_ARRAY_KEYS = ['affectedTravelerIds'];

const SCALAR_ID_PATTERN = new RegExp(`("(?:${SCALAR_ID_KEYS.join('|')})"\\s*:\\s*)(\\d{15,})`, 'g');

// 陣列內容只允許整數、逗號與空白；含字串、巢狀或小數的陣列維持原樣交由 JSON.parse 處理。
// 白名單陣列成員皆為 Long ID，故不套用 scalar 的 15 位門檻，所有成員一律轉為字串。
const ID_ARRAY_PATTERN = new RegExp(`("(?:${ID_ARRAY_KEYS.join('|')})"\\s*:\\s*\\[)(\\s*\\d+(?:\\s*,\\s*\\d+)*\\s*)(\\])`, 'g');

export function parseGroupTripJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw
    .replace(SCALAR_ID_PATTERN, '$1"$2"')
    .replace(ID_ARRAY_PATTERN, (match, head, members, tail) => `${head}${members.replace(/\d+/g, '"$&"')}${tail}`);
  return JSON.parse(text);
}
